<mbs-modal
  #modal
  [isCustomModal]="true">
  <ng-container modal-header>{{ 'mbs-ui:cloud-restore.requestPermissionsModalTitle' | i18next: { title } }}</ng-container>

  <ng-container modal-body>
    <p [innerHTML]="'mbs-ui:cloud-restore.featureEnabledByRequest' | i18next"></p>

    <mbs-input
      type="textarea"
      [boldLabel]="false"
      [formControl]="requestText"
      [label]="'mbs-ui:cloud-restore.requestLabel' | i18next"
      [resize]="'none'"
      [rows]="5"
      [showRequiredMark]="false">
    </mbs-input>

    <div
      class="mt-2"
      [innerHTML]="'mbs-ui:cloud-restore.willBeReviewed' | i18next"></div>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.close' | i18next }}
    </mbs-button>

    <mbs-button
      type="primary"
      [loading]="loading"
      (click)="requestPermissions()">
      {{ 'shared:buttons.sendRequest' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
